import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SharedUserService } from '../../services/shared/user/shared-user.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-hero-section',
  imports: [RouterModule, TranslateModule, CommonModule],
  templateUrl: './hero-section.component.html',
  styleUrl: './hero-section.component.scss',
})
export class HeroSectionComponent implements OnInit {
  public isLoggedIn: boolean = false;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private _sharedUserService: SharedUserService,
    private _changeDetectRef: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.subscribeUserService();
  }

  private subscribeUserService(): void {
    this._sharedUserService.loggedIn$.subscribe((response) => {
      this.isLoggedIn = response ? true : false;
      if (this.isBrowser()) {
        this._changeDetectRef.detectChanges();
      }
    });
  }

  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }
}
